import { ChangeDetectorRef, Component, EventEmitter, Inject, Input, OnInit, Output, SimpleChanges, TemplateRef } from '@angular/core';
import { Event } from '@angular/router';
import { BehaviorSubject, Subject } from 'rxjs';
import { product } from 'src/app/services/AmazonServices';

@Inject({
  providedIn: 'root'
})
export class CustomTreeService{
  
  selected:Subject<{data:product,path:string}> = new Subject();
  path:Subject<string> = new Subject();
  doSave:Subject<boolean> = new Subject();
  
  executeAll(items:product[], open:boolean, parent:string){
    items.forEach(bf=>{
      bf.isopen = open;
      
      let path = parent+'>'+bf.columnName
      if ( parent != null ){
        this.selected.next({data:bf,path:path});
      }
      
      if ( bf.child && bf.child.length > 0 ){
        this.executeAll(bf.child,open,path);
      }
    })
  }
}

@Component({
    selector: 'custom-tree-view',
    templateUrl: './custom-tree-view.component.html',
    styleUrls: ['./custom-tree-view.component.scss'],
    standalone: false
})
export class CustomTreeViewComponent implements OnInit {

  @Input() items:product[];
  @Input() parent:string ="";
  @Input() detail: TemplateRef<any>;
  @Input() before:product;

  constructor(private cts:CustomTreeService) { 
   
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(){
    
  }


  emit(item){
   this.cts.selected.next(item);
  }

  emitPath(data){
    this.cts.path.next(data);
  }

  onexpand(item:product, before:product) {
    item.isopen = !item.isopen;
    /*if (item.isopen) {
      item.isopen = !item.isopen;
      return;
    } else {
      if (item.child) {
        if (item.child.length > 0) {
          item.isopen = true;
        } else {
          item.isopen = true;
        }

        if ( before!= null && item.isopen && before.child.length > 1){
          this.closeChildren(before.child,item.columnName)
        }
        
        
      }else{
          item.isopen = false;
      }
    }*/

  }

  closeChildren(itens:product[],columnName:string){

    itens.forEach(bf=>{
      if ( bf.columnName != columnName ){
        bf.isopen = false;
      }
      if ( bf.child && bf.child.length > 0 ){
        this.closeChildren(bf.child,columnName);

      }
      
    })
  }

  clear(item:product,event:PointerEvent){
      event.preventDefault();
      event.stopPropagation();
      item.isvisible = false;
      this.cts.doSave.next(true);      
  }
}
